import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="min-h-screen bg-pattern-dark text-white" data-id="element-158">
      <Header data-id="element-159" />
      <main className="w-full" data-id="element-160">{children}</main>
      <Footer data-id="element-161" />
    </div>;
};